import { defineMessages } from "../define";

/**
 * Pizza detail, bottom card: what the evaluation was made with (metadata.versions). Model keys, runs_on values,
 * field names and reasons come from the backend; codes without a text here are shown as they are.
 */
export default defineMessages({
  en: {
    "versions.title": "Evaluation versions",
    "versions.modelCount.one": "{count} model",
    "versions.modelCount.few": "{count} models",
    "versions.modelCount.other": "{count} models",
    "versions.notRecordedShort": "not recorded",
    "versions.notRecorded":
      "This evaluation is older than the version record. Re-evaluate the pizza to store which backend and models evaluate it.",
    "versions.backend": "Backend",
    "versions.unknown": "unknown",
    "versions.currentBackend": "now {version}",
    "versions.currentBackendHint": "The backend runs another version now; a re-evaluation may give another result.",
    "versions.settings": "Evaluation settings",
    "versions.settingsVersion": "version {version}",
    "versions.settingsDefaults": "defaults",
    "versions.overrides.one": "{count} change from the defaults",
    "versions.overrides.few": "{count} changes from the defaults",
    "versions.overrides.other": "{count} changes from the defaults",
    "versions.gpuPod": "GPU pod",
    "versions.notRun": "Did not run",
    "versions.reusedUnknown": "version not recorded",
    "versions.reusedHint": "Result taken over from an earlier evaluation of the pizza (its cache), not computed again",

    // where the model ran (runs_on)
    "versions.runsOn.pod": "GPU pod",
    "versions.runsOn.backend": "Backend",
    "versions.runsOn.reused": "Earlier evaluation",

    // models (key)
    "versions.model.crust": "Crust",
    "versions.model.obstacles": "Obstacles",
    "versions.model.blur": "Blur",
    "versions.model.components": "Ingredients",
    "versions.model.sauces": "Sauces",
    "versions.model.doneness": "Doneness",
    "versions.model.slicing": "Slicing",

    // why a model did not run
    "versions.unavailable.model_unavailable": "model not loaded",

    // fields
    "versions.field.file": "file",
    "versions.field.sha256": "sha256",
    "versions.field.pod": "pod",
    "versions.field.git": "git",
    "versions.field.providers": "runtime",
    "versions.field.gpu_decode": "GPU decode",
    "versions.field.gpu_type": "GPU",
    "versions.field.pod_id": "pod ID",
  },
  cs: {
    "versions.title": "Verze vyhodnocení",
    "versions.modelCount.one": "{count} model",
    "versions.modelCount.few": "{count} modely",
    "versions.modelCount.other": "{count} modelů",
    "versions.notRecordedShort": "neuloženo",
    "versions.notRecorded":
      "Toto vyhodnocení je starší než ukládání verzí. Po novém vyhodnocení pizzy se uloží, jaký backend a jaké modely ji vyhodnotily.",
    "versions.backend": "Backend",
    "versions.unknown": "neznámá",
    "versions.currentBackend": "teď {version}",
    "versions.currentBackendHint": "Backend teď běží v jiné verzi; nové vyhodnocení může dopadnout jinak.",
    "versions.settings": "Nastavení vyhodnocení",
    "versions.settingsVersion": "verze {version}",
    "versions.settingsDefaults": "výchozí",
    "versions.overrides.one": "{count} změna oproti výchozím",
    "versions.overrides.few": "{count} změny oproti výchozím",
    "versions.overrides.other": "{count} změn oproti výchozím",
    "versions.gpuPod": "GPU pod",
    "versions.notRun": "Neběžel",
    "versions.reusedUnknown": "verze neuložena",
    "versions.reusedHint": "Výsledek převzatý z dřívějšího vyhodnocení pizzy (z cache), znovu se nepočítal",

    "versions.runsOn.pod": "GPU pod",
    "versions.runsOn.backend": "Backend",
    "versions.runsOn.reused": "Dřívější vyhodnocení",

    "versions.model.crust": "Okraj",
    "versions.model.obstacles": "Překážky",
    "versions.model.blur": "Rozmazání",
    "versions.model.components": "Suroviny",
    "versions.model.sauces": "Omáčky",
    "versions.model.doneness": "Propečení",
    "versions.model.slicing": "Krájení",

    "versions.unavailable.model_unavailable": "model se nenačetl",

    "versions.field.file": "soubor",
    "versions.field.sha256": "sha256",
    "versions.field.pod": "pod",
    "versions.field.git": "git",
    "versions.field.providers": "běh",
    "versions.field.gpu_decode": "GPU dekódování",
    "versions.field.gpu_type": "GPU",
    "versions.field.pod_id": "ID podu",
  },
});
